import "./FilesView.css";

const FileList = ({ files }) => {
  return (
    <div className="file-list">
      <ul>
        {files.map((file, index) => (
          <li key={index}>
            {index + 1}. {file}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FileList;
